// src/components/togglebuttons/GisPanel.js
import React, { useCallback, useRef } from "react"
import { useMap } from "react-leaflet"

import { Paper, IconButton, Typography, Box, Divider } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import ToggleButtonsGeoVectorLayers from "./ToggleButtonsGeoVectorLayers"
import { togglePanel } from "../../reducers/panelsReducer"
import { onMouseLeave } from "@/utils/mapUx"
import VisibilitySwitch from "@/components/ui/VisibilitySwitch";
import { LEFT_PANEL_WIDTH } from "@/config/layout";
import { useLayoutBounds } from "@/features/layout/layoutBounds.jsx";
import { TourHelpButton } from "@/features/tutorials";
import {
  PANEL_TITLE_SX,
  PANEL_SUBTITLE_SX,
  PANEL_CARD_SX,
  CARD_TITLE_SX,
  PANEL_SCROLLBAR_SX,
  PANEL_HEADER_DIVIDER_SX,
} from "@/theme/panelStyles";



export default function GisPanel({
  openPanels,
  dispatch,
  setVoyageActive,
  switchGisLayersActive,
  setSwitchGisLayersActive,
  toogleButtonsOnOff,
  setToogleButtonsOnOff,
}) {
  const map = useMap()
  const isOpen = openPanels.gis
  const panelRef = useRef(null)
  const bounds = useLayoutBounds()
  const panelMaxHeight = bounds.panelHeight

  const handleClose = useCallback(() => {
    dispatch(togglePanel("gis"))
    onMouseLeave(map)
  }, [dispatch])

  if (!isOpen) return null

  return (
    <Paper
      key="gis-panel"
      id="gis-panel"
      data-tour="gis-panel"
      ref={panelRef}
      elevation={0}
      sx={{
        position: "absolute",
        top: bounds.top,
        zIndex: 1000,
        bgcolor: "background.paper",
        width: `${LEFT_PANEL_WIDTH}px`,
        color: "#004f7d",
        borderRadius: "0px",
        marginLeft: `${bounds.left}px`,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        maxHeight: `${panelMaxHeight}px`,
        boxSizing: "border-box",
        p: 1.5,
      }}
      onMouseEnter={() => {
        setVoyageActive(false)
      }}
      onMouseLeave={() => {
        setVoyageActive(true)
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
        <Box>
          <Typography sx={PANEL_TITLE_SX}>GIS Layers</Typography>
          <Typography sx={PANEL_SUBTITLE_SX}>Map overlay controls</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <TourHelpButton tourId="map-layers" />
          <VisibilitySwitch
            data-tour="gis-visibility"
            checked={switchGisLayersActive}
            onChange={(e) => setSwitchGisLayersActive(e.target.checked)}
            slotProps={{ input: { "aria-label": "toggle GIS layers visibility" } }}
          />
          <IconButton aria-label="close" onClick={handleClose} sx={{ color: "#004f7d" }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      <Divider sx={PANEL_HEADER_DIVIDER_SX} />

      <Box
        sx={{
          flex: "0 1 auto",
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          overscrollBehavior: "contain",
          ...PANEL_SCROLLBAR_SX,
        }}
      >
        <Box sx={PANEL_CARD_SX} data-tour="gis-layers">
          <Typography sx={{ ...CARD_TITLE_SX, mb: 1 }}>Available Layers</Typography>
          <Divider sx={{ mb: 1 }} />
          <ToggleButtonsGeoVectorLayers
            toogleButtonsOnOff={toogleButtonsOnOff}
            setToogleButtonsOnOff={setToogleButtonsOnOff}
          />
        </Box>
      </Box>
    </Paper>
  )
}
